import defaultsJson from "./widgetDefaults.json";
import { DEFAULT_FONT_STACK } from "../utils/calendarFontFamily";

const raw = defaultsJson;
export const WIDGET_TEMPLATE_IDS = Object.keys(raw.templates || {});

export const EVENT_DEFAULTS = Object.freeze({ ...raw.eventDefaults });

export function buildDemoStartAt(daysAhead = 0) {
  const d = new Date();
  d.setDate(d.getDate() + daysAhead);
  d.setHours(10, 0, 0, 0);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T10:00`;
}

export function mergeAppearanceForTemplate(templateId) {
  const tpl = raw.templates?.[templateId];
  const common = { ...raw.commonAppearance };
  if (!tpl) return common;
  return { ...common, ...(tpl.appearance || {}) };
}

/** Shared baseline used when no template is selected yet. */
export const APPEARANCE_DEFAULTS = mergeAppearanceForTemplate(
  raw.starterTemplateId || "classic-forest",
);

export function getAppearanceForTemplate(templateId) {
  return mergeAppearanceForTemplate(templateId || raw.starterTemplateId || "classic-forest");
}

export function buildDemoEventForTemplate(templateId) {
  const tpl = raw.templates?.[templateId] || {};
  return {
    ...EVENT_DEFAULTS,
    ...raw.demoEvent,
    ...tpl.demoEvent,
    startAt: raw.demoEvent?.startAt || buildDemoStartAt(),
  };
}

export function buildInstallDemoEvent(templateId) {
  return buildDemoEventForTemplate(templateId || raw.starterTemplateId || "classic-forest");
}

/**
 * When switching templates, apply preset colors/fonts for the new template
 * only where values still match the previous template preset (or global baseline).
 */
export function mergeAppearanceOnTemplateChange(current, oldTemplateId, newTemplateId) {
  const next = getAppearanceForTemplate(newTemplateId);
  const prev = getAppearanceForTemplate(oldTemplateId);
  const merged = { ...(current || {}) };
  for (const key of Object.keys(next)) {
    const cur = merged[key];
    if (cur === undefined || cur === prev[key] || cur === APPEARANCE_DEFAULTS[key]) {
      merged[key] = next[key];
    }
  }
  return merged;
}

export const TEMPLATE_DEFAULTS_CATALOG = Object.fromEntries(
  WIDGET_TEMPLATE_IDS.map((id) => {
    const tpl = raw.templates[id];
    return [
      id,
      {
        label: tpl?.label || id,
        widgetName: tpl?.widgetName || raw.widgetName,
        appearance: mergeAppearanceForTemplate(id),
        eventDefaults: { ...EVENT_DEFAULTS, ...(tpl?.demoEvent || {}) },
      },
    ];
  }),
);

export { DEFAULT_FONT_STACK, raw as widgetDefaultsConfig };
